module.exports = __webpack_public_path__ + "static/media/bannernoticias.ebe4daf3.jpg";